var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step"},[_c('h2',[_vm._v(_vm._s(_vm.step))]),_vm._v(" "),_c('div',{staticClass:"pic",style:({backgroundImage: 'url('+_vm.picStr+')'})}),_vm._v(" "),_c('div',{staticClass:"text-content"},_vm._l((_vm.textArr),function(item,i){return _c('p',{key:i,staticClass:"text"},[_vm._v(_vm._s(item))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ae10a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepPic/StepPic.vue
// module id = null
// module chunks = 